<template>
  <div style="flex:1;height: 1px;display: flex;flex-direction:column;margin: 0px 0 10px 0;">
    <div style="width: 100%;height: 100%;
            border: 1px solid rgba(43, 143, 222, 1);
            position: relative;
            box-sizing: border-box;">
      <div style="width: 100%; height: 100%; display: flex;">
        <template v-if="simList.length">
          <!-- 目录 -->
          <div
              style="
                  width: 150px;
                  background-color: #d6deee;
                  padding: 10px;
                  display: flex;
                  flex-direction: column;
                  box-sizing: border-box;
                  border-right: 1px solid rgba(163, 188, 208, 1);
                "
          >
            <div
                style="
                    font-weight: 700;
                    font-style: normal;
                    font-size: 14px;
                    color: #333333;
                    height: 33px;
                    line-height: 33px;
                    text-align: center;
                  "
            >
              目录
            </div>
            <div
                ref="muluContainer"
                style="flex: 1; background: #fff; overflow: auto"
            >
              <el-collapse v-model="activeGroupIdx" accordion>
                <template v-for="(item, idx) in showGroupSims">
                  <el-collapse-item :key="idx" :name="idx">
                    <template slot="title">
                      <p v-if="item.category === 0" class="catalogue_title">{{ `投标异常组${idx + 1}` }}</p>
                      <p v-else class="catalogue_title">{{ `招标相似组${idx + 1}` }}</p>
                    </template>
                    <template v-for="_item in item.sims">
                      <p :key="_item.simIdx"
                         :class="{
                               active_catalogue_item: _item.index == currentIdx
                             }"
                         class="catalogue_item"
                         @click="changeCatalog(_item)"
                      >{{ `${item.category == 1 ? '相似项' : '异常项'}${_item.index + 1}` }}</p>
                    </template>
                  </el-collapse-item>
                </template>
              </el-collapse>
            </div>
          </div>
          <div style="flex:1;
                  width: 1px;
                  border-right: 1px solid rgba(43, 143, 222, 1);
                  display: flex;
                  flex-direction: column;
                  position: relative;
                  ">
            <div class="pdfTitle">
              【{{ baseData.name }}】- {{ baseData.mulu }}
            </div>
            <div ref="baseContainer" style="flex:1;height: 1px;display: flex;flex-direction: column;overflow: auto;"
                 @scroll="onBaseScroll">
              <div
                  style="flex: 1; position: relative; width: 605px;margin: 0 auto; "
              >
                <div
                    :style="{
                      height: baseData.totalPage * 842 + 'px',
                    }"
                    style="position: relative; width: 605px">
                  <template v-for="index in baseData.totalPage">
                    <div
                        v-if="
                          index <= baseCurrentPage + 1 &&
                          index >= baseCurrentPage - 1
                        "
                        :key="index"
                        :ref="`basePage${index}`"
                        v-loading="!baseData.pageInfos[index - 1].load"
                        :style="{
                          top: (index - 1) * 843 + 'px',
                        }"
                        style="
                          position: absolute;
                          width: 605px;
                          height: 842px;
                          border-bottom: 1px solid #000;
                        "
                    >
                      <template
                          v-if="
                            baseSims[index] && baseData.pageInfos[index - 1].load
                          "
                      >
                        <template v-for="item in baseSims[index]">
                          <template v-if="item.info.length == 1">
                            <div
                                v-if="currentGroupId == item.groupId"
                                :key="item.key"
                                :class="{ sim_active1: (item.key == currentIdx&&item.category ==0),sim_active2: (item.key == currentIdx&&item.category ==1) }"
                                :style="{
                                    width: item.info[0].pos.width + 'px',
                                    height: item.info[0].pos.height + 'px',
                                    top: item.info[0].pos.top + 'px',
                                    left: item.info[0].pos.left + 'px',
                                    background: item.category == 0?'rgba(217, 0, 27, 0.2)':'rgba(255,242,0,0.2)',
                                    position: 'absolute'
                                  }"
                                class="simModel"
                                @click="simClick(item)"
                            ></div>

                          </template>
                          <template v-if="item.info.length>1">
                            <div>
                              <div v-if="currentGroupId == item.groupId" :key="item.key"
                                   :style="{
                                  top: item.info[0].pos.top + 'px',
                                  left: (item.info[0].pos.left-30) + 'px',
                                  zIndex:item.key == currentIdx?999:1
                                  }"
                                   style="position: absolute;">
                                <div v-for="(_item,_idx) in item.info" :key="_idx"
                                     :class="{simModel_tag_active1:(_item.key == currentIdx+'_'+currentSubIdx && item.category == 0),simModel_tag_active2:(_item.key == currentIdx+'_'+currentSubIdx && item.category == 1)}"
                                     :style="{
                                    background: item.category == 0?'rgba(217, 0, 27, 0.2)':'rgba(73,70,6,0.2)'
                                 }"
                                     class="simModel_tag"
                                     @click="change_simModel_tag(_item)">
                                  {{ _idx + 1 }}
                                </div>
                              </div>
                              <div
                                  v-if="currentGroupId == item.groupId"
                                  :key="item.key+1"
                                  :class="{sim_active1:(item.key ==currentIdx && item.category ==0),sim_active2:(item.key == currentIdx&& item.category ==1)}"
                                  :style="{
                                  width: item.info[0].pos.width + 'px',
                                  height: item.info[0].pos.height + 'px',
                                  top: item.info[0].pos.top + 'px',
                                  left: item.info[0].pos.left + 'px',
                                  background: item.category == 0?'rgba(217, 0, 27, 0.2)':'rgba(255,242,0,0.2)'
                                }"
                                  class="simModel"
                                  style="position: absolute;"
                                  @click="simClick(item)"
                              ></div>
                            </div>
                          </template>
                        </template>
                      </template>
                      <div
                          style="
                            width: 70px;
                            height: 30px;
                            position: absolute;
                            bottom: 3px;
                            line-height: 30px;
                            left: 267px;
                            text-align: center;
                          "
                      >
                        {{ index }}/{{ baseData.totalPage }}
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>

          </div>
          <div style="width: 2px"></div>
          <div
              style="
                  flex: 1;
                   width: 1px;
                  border-left: 1px solid rgba(43, 143, 222, 1);
                  display: flex;
                  flex-direction: column;
                "
          >
            <div class="pdfTitle">
              【{{ contData.name }}】- {{ contData.mulu }}
            </div>
            <div ref="contContainer" style="flex:1;height: 1px;display: flex;flex-direction: column;overflow: auto;"
                 @scroll="onContScroll">
              <div
                  style="flex: 1; position: relative; width: 605px;margin: 0 auto; "
              >
                <div
                    :style="{
                      height: contData.totalPage * 842 + 'px',
                    }"
                    style="position: relative; width: 605px"
                >
                  <template v-for="index in contData.totalPage">
                    <div
                        v-if="
                          index <= contCurrentPage + 1 &&
                          index >= contCurrentPage - 1
                        "
                        :key="index"
                        :ref="`contPage${index}`"
                        v-loading="!contData.pageInfos[index - 1].load"
                        :style="{
                          top: (index - 1) * 843 + 'px',
                        }"
                        style="
                          position: absolute;
                          width: 605px;
                          height: 842px;
                          border-bottom: 1px solid #000;
                        "
                    >
                      <template
                          v-if="
                            contSims[index] && contData.pageInfos[index - 1].load
                          "
                      >
                        <template v-for="item in contSims[index]">
                          <div
                              v-if="currentGroupId == item.groupId"
                              :key="item.key"
                              :class="{ right_sim_active1: (item.key == currentIdx+'_'+currentSubIdx && item.category ==0),ringt_sim_active2: (currentIdx+'_'+currentSubIdx && item.category ==1) }"
                              :style="{
                            width: item.pos.width + 'px',
                            height: item.pos.height + 'px',
                            top: item.pos.top + 'px',
                            left: item.pos.left + 'px',
                            background: item.category == 0?'rgba(217, 0, 27, 0.2)':'rgba(255,242,0,0.2)'
                          }"
                              class="simModel"
                              style="
                            position: absolute;
                          "
                          ></div>
                        </template>
                      </template>
                      <div
                          style="
                            width: 70px;
                            height: 30px;
                            position: absolute;
                            bottom: 3px;
                            line-height: 30px;
                            left: 267px;
                            text-align: center;
                          "
                      >
                        {{ index }}/{{ contData.totalPage }}
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>

          </div>
        </template>
        <template v-else>
          <div
              style="width: 100%;height: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;">
            <img alt="" src="@/assets/image/e1.png"/>
            <div
                style="
                  font-weight: 400;
                  font-style: normal;
                  font-size: 14px;
                  color: rgb(85, 85, 85);
                  margin-top: 10px;
                  line-height: 28px;
                  height: 28px;
                  text-align: center;
                "
            >
              没有异常相似哦~
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {getPdfDataImg} from "@/api/pdf";

export default {
  name: "textCmp",
  props: {
    companyData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      simList: [],
      groupSims: [],
      currentGroupId: 0,
      activeGroupIdx: 0,
      currentIdx: 0,
      currentSubIdx: 0,
      baseData: {},
      contData: {},
      baseContainer: null,
      baseScroll: null,
      baseCurrentPage: 1,
      contContainer: null,
      contScroll: null,
      contCurrentPage: 1,
      currentItem: null,
      muluContainer: null,
    }
  },
  async mounted() {
    await this.init();
    this.$nextTick(() => {
      this.baseContainer = this.$refs.baseContainer
      this.contContainer = this.$refs.contContainer
      this.muluContainer = this.$refs.muluContainer
      this.baseScroll = this.$_.debounce(this.baseScrollChange, 500)
      this.contScroll = this.$_.debounce(this.contScrollChange, 500)
    })
  },
  methods: {
    init() {
      const self = this;
      this.groupSims = this.companyData.details;
      this.groupSims = this.$_.filter(this.groupSims, (item) => {
        return item.sims.length !== 0
      });
      this.simList = []
      this.$_.each(this.groupSims, (item, idx) => {
        item.groupId = idx
        this.$_.each(item.sims, (_item) => {
          _item.cont_name = item.cont_name
          _item.name = item.name
          _item.file = item.file
          _item.mulu = item.mulu
          _item.cont_mulu = item.cont_mulu
          _item.cont_file = item.cont_file
          _item.page_num = item.page_num
          _item.cont_page_num = item.cont_page_num
          _item.groupId = idx
          _item.category = item.category

          // 默认取了  该异常项下的第一个异常数据
          _item.page = _item.info[0].page;
          _item.cont_page = _item.info[0].cont_page;
        })
        this.simList = this.simList.concat(item.sims);
      });

      // 默认取第一个异常
      this.currentIdx = 0;
      this.currentSubIdx = 0;

      this.currentItem = this.$_.find(this.simList, function (item) {
        return item.index === self.currentIdx
      })

      if (this.currentItem) {
        this.activeGroupIdx = this.currentItem.groupId
        this.changeCatalog(this.currentItem)
      }

    },
    /**
     * 切换异常
     */
    changeCatalog(item) {
      this.currentIdx = item.index
      this.currentSubIdx = 0;
      this.currentGroupId = item.groupId
      this.baseCurrentPage = item.page
      this.contCurrentPage = item.cont_page
      this.baseData = {
        name: item.name,
        mulu: item.mulu,
        url: item.file,
        page: item.page,
        totalPage: item.page_num,
        pageInfos: this.$_.times(item.page_num, (_item) => {
          return {
            index: _item,
            load: false
          }
        })
      }
      this.contData = {
        name: item.cont_name,
        mulu: item.cont_mulu,
        url: item.cont_file,
        page: item.cont_page,
        totalPage: item.cont_page_num,
        pageInfos: this.$_.times(item.cont_page_num, (_item) => {
          return {
            index: _item,
            load: false
          }
        })
      }
      this.$nextTick(() => {
        this.baseContainer = this.$refs.baseContainer
        this.contContainer = this.$refs.contContainer
        this.muluContainer = this.$refs.muluContainer
        this.baseContainer.scrollTop = 0
        this.baseContainer.scrollTop = (this.baseData.page - 1) * 843
        if (this.baseData.page == 1) {
          this.loadBasePDF(this.baseData.url, this.baseData.page)
        }
        this.contContainer.scrollTop = 0
        this.contContainer.scrollTop = (this.contData.page - 1) * 843
        if (this.contData.page == 1) {
          this.loadContPDF(this.contData.url, this.contData.page)
        }
      })
    },
    /**
     * 加载基准PDF
     * @param url
     * @param page
     * @returns {Promise<void>}
     */
    async loadBasePDF(url, page) {
      const tempImg = document.getElementById(`baseImg${page}`)
      if (tempImg && this.baseData.pageInfos[page - 1].load == true) {

      } else {
        this.baseData.pageInfos[page - 1].load = false
        const res = await getPdfDataImg({
//           project: "79b067b0-db95-45da-8494-3fcbbb0b8e81",
// sign_name: 1710312137,
project: this.projectId,
        sign_name: this.sign_name,
          file: url,
          page: page
        })
        this.renderBase(page, res.data)
      }
    },
    /**
     * 渲染基准pdf
     * @param page
     * @param res
     */
    renderBase(page, res) {
      const tempContainer = this.$refs[`basePage${page}`][0]
      const tempImg = document.getElementById(`baseImg${page}`)
      if (tempImg) {
        tempContainer.removeChild(tempImg)
      }
      const Img = document.createElement('img')
      Img.id = `baseImg${page}`
      Img.src = res.url;
      tempContainer && tempContainer.appendChild(Img)
      setTimeout(() => {
        this.baseData.pageInfos[page - 1].load = true
      }, 0)
    },
    /**
     * 基准pdf滚动事件 处理
     */
    baseScrollChange() {
      this.baseCurrentPage = Math.round(this.baseContainer.scrollTop / 843)
          ? Math.round(this.baseContainer.scrollTop / 843) + 1
          : 1
      if (this.baseCurrentPage - 1 >= 1) {
        this.loadBasePDF(this.baseData.url, this.baseCurrentPage - 1)
      }
      this.loadBasePDF(this.baseData.url, this.baseCurrentPage)

      if (this.baseCurrentPage + 1 <= this.baseData.totalPage) {
        this.loadBasePDF(this.baseData.url, this.baseCurrentPage + 1)
      }
    },
    /**
     * 加载对比pdf
     * @param url
     * @param page
     * @returns {Promise<void>}
     */
    async loadContPDF(url, page) {
      const tempImg = document.getElementById(`contImg${page}`)
      if (tempImg && this.contData.pageInfos[page - 1].load == true) {

      } else {
        this.contData.pageInfos[page - 1].load = false
        const res = await getPdfDataImg({
//           project: "79b067b0-db95-45da-8494-3fcbbb0b8e81",
// sign_name: 1710312137,
project: this.projectId,
        sign_name: this.sign_name,
          file: url,
          page: page
        })
        this.renderCont(page, res.data)
      }
    },
    /**
     * 对比pdf滚动事件处理函数
     */
    contScrollChange() {
      this.contCurrentPage = Math.round(this.contContainer.scrollTop / 843)
          ? Math.round(this.contContainer.scrollTop / 843) + 1
          : 1
      if (this.contCurrentPage - 1 >= 1) {
        this.loadContPDF(this.contData.url, this.contCurrentPage - 1)
      }
      this.loadContPDF(this.contData.url, this.contCurrentPage)

      if (this.contCurrentPage + 1 <= this.contData.totalPage) {
        this.loadContPDF(this.contData.url, this.contCurrentPage + 1)
      }
    },
    /**
     * 基准pdf滚动
     */
    onBaseScroll() {
      this.baseScroll()
    },
    /**
     * d对比pdf滚动
     */
    onContScroll() {
      this.contScroll()
    },
    /**
     * 渲染对比pdf
     * @param page
     * @param res
     */
    renderCont(page, res) {
      const tempContainer = this.$refs[`contPage${page}`][0]
      const tempImg = document.getElementById(`contImg${page}`)
      if (tempImg) {
        tempContainer.removeChild(tempImg)
      }
      const Img = document.createElement('img')
      Img.id = `contImg${page}`
      Img.src = res.url;
      tempContainer && tempContainer.appendChild(Img)

      this.contData.pageInfos[page - 1].load = true
    },
    /**
     * 当前异常是否在 该异常组中
     * @param item
     * @param currentIdx
     * @returns {boolean}
     */
    keyIs(item, currentIdx) {
      const keys = this.$_.pluck(item, 'key')
      if (this.$_.indexOf(keys, currentIdx) === -1) {
        return false
      } else {
        return true
      }
    },
    change_simModel_tag(item) {
      let temp = item.key.split("_");
      this.currentIdx = temp[0];
      this.currentSubIdx = temp[1]
      this.ChangeContShow()
    },
    /**
     * 异常项点击
     * @param sim
     */
    simClick(sim) {
      this.currentIdx = sim.key
      this.currentSubIdx = 0;
      this.ChangeContShow()
    },
    /**
     * 点击基准页  异常  切换对比页
     * @constructor
     */
    ChangeContShow() {
      let temp = null
      // 查找对比页面的异常项   key相同
      this.$_.each(this.contSims, (item) => {
        this.$_.each(item, (s) => {
          if (s.key === this.currentIdx+"_"+this.currentSubIdx) {
            temp = s
          }
        })
      })
      if (temp) {
        if (temp.page === this.contCurrentPage) {

        } else {
          this.contContainer.scrollTop = (temp.page - 1) * 843
        }
      }
    },
  },
  computed: {
    ...mapState('pdf', ['projectId', 'sign_name']),
    baseSims() {
      let temp = this.$_.map(this.simList, (item) => {
        let info = this.$_.map(item.info, (_item, idx) => {
          let i = {
            key: item.index + "_" + idx,
            page: _item.page,
            pos: {
              width: _item.pos[2] - _item.pos[0],
              height: _item.pos[3] - _item.pos[1],
              top: _item.pos[1],
              left: _item.pos[0]
            },
            text: _item.text,
            cont_text: _item.cont_text
          }
          return i;
        })
        const t = {
          key: item.index,
          info: info,
          groupId: item.groupId,
          page: item.page,
          category: item.category
        }
        return t
      })
      temp = this.$_.groupBy(temp, 'page')
      return temp;
    },
    contSims() {
      const temp = {}
      this.$_.each(this.simList, (item) => {
        let info = item.info;
        this.$_.each(info, (_item, idx) => {
          if (!temp[_item.cont_page]) {
            temp[_item.cont_page] = []
          }
          temp[_item.cont_page].push({
            key: item.index + '_' + idx,
            pos: {
              width: _item.cont_pos[2] - _item.cont_pos[0],
              height: _item.cont_pos[3] - _item.cont_pos[1],
              top: _item.cont_pos[1],
              left: _item.cont_pos[0]
            },
            groupId: item.groupId,
            page: _item.cont_page,
            category: item.category
          })
        })
      })
      return temp
    },
    showGroupSims() {
      const temp = this.$_.filter(this.groupSims, (item) => {
        return item.sims.length !== 0
      })
      return temp
    }
  },
  watch: {
    companyData(val) {
      this.init();
    },
    baseCurrentPage(nVal) {
      if (!this.baseSims.hasOwnProperty(nVal)) {

      } else {
        let arr = []
        // 当前页面的异常
        const t = this.baseSims[nVal]
        //  有1对多的情况 将结构转换成简单结构
        this.$_.each(t, (item) => {
          arr = arr.concat(item)
        })
        arr = this.$_.filter(arr, (item) => {
          // 找出当前页   属于当前异常组的异常项
          return item.groupId === this.currentGroupId
        })
        // 对找出来的异常项进行排序
        arr = this.$_.sortBy(arr, (item) => {
          return item.key
        })
        if (arr.length === 0) {

        } else {
          // 查找当前页面是否有当前选中的异常
          const temp = this.$_.filter(arr, (item) => {
            return item.key === this.currentIdx
          })
          if (!temp[0]) {
            const selected = arr[0]
            this.currentIdx = selected.key
          }
          this.ChangeContShow()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.noSimContainer {
  width: 320px;
  height: 180px;
  position: absolute;
  top: calc(50% - 90px);
  left: calc(50% - 160px);

  .noSim_img {
    width: 320px;
    height: 152px;
    display: block;
    margin: 0 auto;
  }
}

.sim_tip_text {
  font-weight: 700;
  font-style: normal;
  font-size: 12px;
  color: #333;
}

.table {
  width: 800px;
  margin-left: 16px;
  margin-top: 10px;
}

.red {
  color: #d9001b;
}

.green {
  color: #13b002;
}

.catalogue_item {
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin-top: 5px;
  cursor: pointer;
  font-size: 13px;
  position: relative;
}

.catalogue_title {
  height: 30px;
  line-height: 30px;
  text-align: center;
  // margin-top: 5px;
  font-size: 13px;
  position: relative;
  background-color: #f6f6f6;
  flex: 1;

}

.active_catalogue_item {
  background-color: #d6deee;
  font-weight: 700;
  font-style: normal;
  font-size: 13px;
  color: #000;
  position: relative;

  &::after {
    content: "";

    display: block;
    width: 5px;
    height: 30px;
    background-color: #d6deee;
    position: absolute;
    left: 0;
    top: 0;
  }
}

.pdfTitle {
  height: 43px;
  border-bottom: 1px solid rgba(163, 188, 208, 1);
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  line-height: 43px;
  text-align: center;
}

.simModel {
  border-radius: 5px;
}

.sim_active {
  border: 2px solid #ff5d3f;
}

.simModel_tag {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  //background: rgba(217, 0, 27, 0.2);
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  margin-bottom: 5px;
  cursor: pointer;

}

.simModel_tag_active1 {
  background: #d9001b !important;

}

.simModel_tag_active2 {
  background: #c8c823 !important;

}

.sim_active1,.right_sim_active1 {
  border: 2px solid #d9001b;
}


.sim_active2 {
  border: 2px solid #c8c823;
}


</style>
